import { Typography } from "@joonapp/web-shared"
import queryString from "query-string"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../util/analytics"

const IOSCancelSubscription = () => {
  const location = useLocation()
  const params = queryString.parse(location.search)
  const subscriptionId = params.subscription_id as string
  const customerId = params.customer_id as string
  const churnkeyAuthHash = params.churnkey_auth_hash as string
  const [isModalClosed, setIsModalClosed] = useState(false)

  useEffect(() => {
    if (subscriptionId && customerId && churnkeyAuthHash) {
      trackAnalyticEvent(ANALYTIC_EVENTS.CHURNKEY_OPEN, {
        source: "ios",
      })

      // @ts-ignore
      window.churnkey.init("show", {
        customerId,
        subscriptionId,
        authHash: churnkeyAuthHash,
        appId: "7h9b3hvtt",
        mode: "live",
        provider: "stripe",
        record: true,
        onClose: () => {
          trackAnalyticEvent(ANALYTIC_EVENTS.CHURNKEY_CLOSE, {
            source: "ios",
          })
          setIsModalClosed(true)
          // Close the webview or navigate back
          window.close()
        },
        onCancel: () => {
          trackAnalyticEvent(ANALYTIC_EVENTS.CHURNKEY_CANCEL, {
            source: "ios",
          })
        },
        onPause: () => {
          trackAnalyticEvent(ANALYTIC_EVENTS.CHURNKEY_PAUSE, {
            source: "ios",
          })
        },
        onDiscount: () => {
          trackAnalyticEvent(ANALYTIC_EVENTS.CHURNKEY_DISCOUNT_CHANGE, {
            source: "ios",
          })
        },
        onPlanChange: () => {
          trackAnalyticEvent(ANALYTIC_EVENTS.CHURNKEY_PLAN_CHANGE, {
            source: "ios",
          })
        },
        onResume: () => {
          trackAnalyticEvent(ANALYTIC_EVENTS.CHURNKEY_RESUME, {
            source: "ios",
          })
        },
        onStepChange: (newStep: string, oldStep: string) => {
          trackAnalyticEvent(ANALYTIC_EVENTS.CHURNKEY_STEP_CHANGE, {
            source: "ios",
            newStep,
            oldStep,
          })
        },
      })
    }
  }, [subscriptionId, customerId, churnkeyAuthHash])

  return (
    <div>
      {isModalClosed && (
        <div className="flex flex-col justify-center items-center h-screen">
          <Typography variant="body">You can close this page now</Typography>
        </div>
      )}
    </div>
  )
}

export default IOSCancelSubscription
